<pagination-controls previousLabel="Prev" nextLabel="Next" [responsive]="true" [maxSize]='9'
  (pageChange)="handlePageChange($event)">
</pagination-controls>
